import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import { useParams, useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Save,
  UserRound,
  FileText,
  MessageSquare,
  History,
  Paperclip,
  Search,
  X,
  UploadCloud,
  Send,
} from "lucide-react";
import Layout, { Container } from "../components/layout";
import { getCookie } from "../config/webStorage";

// ManageGrievance — Full professional version
// Features:
// - Fetch grievance details
// - Edit details (category, subcategory, title, description, priority, status)
// - Assignment drawer (search employees, assign)
// - Comments UI (public/internal) with attachments
// - Attachments manager (upload + download list)
// - History timeline

const PRIORITY_OPTIONS = ["LOW", "MEDIUM", "HIGH", "CRITICAL"];
const STATUS_OPTIONS = [
  "OPEN",
  "ASSIGNED",
  "IN_PROGRESS",
  "RESOLVED",
  "CLOSED",
  "REOPENED",
  "ESCALATED",
];

export default function ManageGrievance() {
    const token = getCookie("swtoken"); // get auth token
  const { grievanceObjId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState("details");

  // form state mirrors editable fields
  const [form, setForm] = useState({
    category: "",
    subcategory: "",
    title: "",
    description: "",
    priority: "MEDIUM",
    status: "OPEN",
  });

  // Assignment drawer
  const [showAssignDrawer, setShowAssignDrawer] = useState(false);
  const [empQuery, setEmpQuery] = useState("");
  const [employees, setEmployees] = useState([]);
  const [assigning, setAssigning] = useState(false);

  // Comments
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [commentVisibility, setCommentVisibility] = useState("public");
  const [commentFile, setCommentFile] = useState(null);
  const [postingComment, setPostingComment] = useState(false);

  // Attachments
  const [attachments, setAttachments] = useState([]);
  const attachmentRef = useRef(null);
  const [uploadingAttachment, setUploadingAttachment] = useState(false);

  useEffect(() => {
    fetchDetails();
  }, [grievanceObjId]);

  // Fetch grievance details once
  async function fetchDetails() {
    setLoading(true);
    try {
      const res = await axios.get(`${apiurl}/api/grievance/get/${grievanceObjId}`);
      const g = res.data.grievance;
      setData(g);
      setForm((prev) => ({
        ...prev,
        category: g.category || "",
        subcategory: g.subcategory || "",
        title: g.title || "",
        description: g.description || "",
        priority: g.priority || "MEDIUM",
        status: g.status || "OPEN",
      }));

      setComments(g.comments || []);
      setAttachments(g.attachments || []);
    } catch (err) {
      console.error("fetchDetails", err);
      alert("Failed to load grievance");
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const saveChanges = async () => {
    setSaving(true);
    try {
      await axios.put(`${apiurl}/api/grievance/update/${grievanceObjId}`, form);
      await fetchDetails();
      setSaving(false);
      alert("Saved successfully");
    } catch (err) {
      console.error("saveChanges", err);
      setSaving(false);
      alert("Save failed");
    }
  };

  // Assignment drawer helpers
//   useEffect(() => {
//     // simple debounce for employee search
//     const id = setTimeout(() => {
//       if (empQuery && showAssignDrawer) fetchEmployees(empQuery);
//     }, 350);
//     return () => clearTimeout(id);
//   }, [empQuery, showAssignDrawer]);

//   async function fetchEmployees(q) {
//     try {
//       const res = await axios.get(`${apiurl}/api/employees?search=${encodeURIComponent(q)}`);
//       setEmployees(res.data?.employees || []);
//     } catch (err) {
//       console.error("fetchEmployees", err);
//       setEmployees([]);
//     }
//   }


// useEffect(() => {
// // simple debounce for employee search
// const id = setTimeout(() => {
// if (empQuery && showAssignDrawer) fetchEmployees(empQuery);
// }, 350);
// return () => clearTimeout(id);
// }, [empQuery, showAssignDrawer]);


// async function fetchEmployees(q) {
// try {
// const res = await axios.get(`${apiurl}/api/user/search?search=${encodeURIComponent(q)}&limit=50`);
// setEmployees(res.data?.users || []);
// } catch (err) {
// console.error("fetchEmployees", err);
// setEmployees([]);
// }
// }

  
//   async function assignTo(emp) {
//     if (!emp) return;
//     setAssigning(true);
//     try {
//       // payload shape depends on backend — sending assignee object
//       await axios.post(`${apiurl}/api/grievance/assign/${grievanceObjId}`, {
//         assignee: {
//           userName: emp.name || emp.userName || emp.fullName,
//           userEmail: emp.email || emp.userEmail,
//           userObjId: emp._id || emp.id,
//           employeeCode: emp.employeeCode || emp.code || "",
//         },
//       });

//       // refresh details
//       await fetchDetails();
//       setShowAssignDrawer(false);
//     } catch (err) {
//       console.error("assignTo", err);
//       alert("Assign failed");
//     } finally {
//       setAssigning(false);
//     }
//   }


useEffect(() => {
  const id = setTimeout(() => {
    if (empQuery && showAssignDrawer) fetchEmployees(empQuery);
  }, 350);
  return () => clearTimeout(id);
}, [empQuery, showAssignDrawer]);

async function fetchEmployees(q) {
  try {
    const res = await axios.get(
      `${apiurl}/api/user/search?search=${encodeURIComponent(q)}&limit=50`
    );
    setEmployees(res.data?.users || []);
  } catch (err) {
    console.error("fetchEmployees", err);
    setEmployees([]);
  }
}


// ✅ Correct Assign Function — matches your backend API exactly
async function assignTo(emp) {
  if (!emp) return;
  setAssigning(true);

  try {
    await axios.put(`${apiurl}/api/grievance/assignToUser`,
      {
        grievanceObjId,   // <- use same variable you already have
        assignee: {
          userName: emp.firstName + " " + emp.lastName || emp.name,
          userEmail: emp.userEmail || emp.email,
          userObjId: emp._id || emp.id,
          employeeCode: `SUW${emp.employeeDetails.employeeId || emp.employeeCode || ""}`
        }
      },
      {
        headers: {
          Authorization: token, // ensure token is passed
        }
      }
    );

    await fetchDetails();           // refresh UI
    setShowAssignDrawer(false);     // close drawer

  } catch (err) {
    console.error("assignTo Error:", err);
    alert(err?.response?.data?.message || "Assignment failed");
  } finally {
    setAssigning(false);
  }
}


  // Comments
  const onCommentFile = (e) => setCommentFile(e.target.files?.[0] || null);

  async function postComment() {
    if (!commentText && !commentFile) {
      alert("Please add a comment or attach a file");
      return;
    }
    setPostingComment(true);
    try {
      const fd = new FormData();
      fd.append("comment", commentText);
      fd.append("visibility", commentVisibility || "public");
      if (commentFile) fd.append("attachment", commentFile);

      const res = await axios.post(`${apiurl}/api/grievance/comment/${grievanceObjId}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // append new comment (backend should return created comment)
      const created = res.data?.comment;
      if (created) setComments((c) => [created, ...c]);
      setCommentText("");
      setCommentFile(null);
      if (attachmentRef.current) attachmentRef.current.value = null;
    } catch (err) {
      console.error("postComment", err);
      alert("Comment failed");
    } finally {
      setPostingComment(false);
    }
  }

  // Attachments manager
  const onAttachmentFile = (e) => {
    const f = e.target.files?.[0];
    if (f) uploadAttachment(f);
  };

  async function uploadAttachment(file) {
    setUploadingAttachment(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      // backend endpoint should return uploaded metadata { filename, url }
      const res = await axios.post(`${apiurl}/api/grievance/attachment/${grievanceObjId}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const att = res.data?.attachment;
      if (att) setAttachments((a) => [att, ...a]);
    } catch (err) {
      console.error("uploadAttachment", err);
      alert("Upload failed");
    } finally {
      setUploadingAttachment(false);
    }
  }

  async function removeAttachment(idx) {
    const att = attachments[idx];
    if (!att) return;
    // if (!confirm("Delete this attachment?")) return;
    try {
      await axios.delete(`${apiurl}/api/grievance/attachment/${grievanceObjId}`, { data: { url: att.url } });
      setAttachments((a) => a.filter((_, i) => i !== idx));
    } catch (err) {
      console.error("removeAttachment", err);
      alert("Delete failed");
    }
  }

  if (loading) return (
    <Layout>
      <Container>
        <div className="p-8 text-center">Loading...</div>
      </Container>
    </Layout>
  );

  return (
    <Layout>
      <Container overflow={"overflow-auto"}>
        <div className="mx-auto m-2 p-4 bg-slate-50">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-4">
              <button onClick={() => navigate(-1)} className="p-2 rounded hover:bg-gray-100">
                <ArrowLeft size={18} />
              </button>
              <div>
                <h2 className="text-2xl font-semibold">{data.title}</h2>
                <p className="text-sm text-gray-500">ID #{data.id} • Created {new Date(data.createdAt).toLocaleString()}</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <button onClick={saveChanges} disabled={saving} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-2 rounded">
                <Save size={16} /> {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>

          {/* Ticket top card: requester, assignee, status/priority */}
          <div className="bg-white rounded-lg shadow-sm border p-4 mb-6 grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
            {/* Requester */}
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-semibold text-lg">
                {data.requester?.userName?.charAt(0)?.toUpperCase() || "U"}
              </div>
              <div>
                <div className="font-medium">{data.requester?.userName}</div>
                <div className="text-xs text-gray-500">{data.requester?.employeeCode} • {data.requester?.userEmail}</div>
              </div>
            </div>

            {/* Assignee */}
            <div className="flex items-center gap-3">
              <div className="text-xs text-gray-400">Assigned To</div>
              {data.assignee ? (
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-green-100 text-green-700 flex items-center justify-center font-semibold text-sm">{data.assignee.userName?.charAt(0)?.toUpperCase()}</div>
                  <div>
                    <div className="font-medium">{data.assignee.userName}</div>
                    <div className="text-xs text-gray-500">{data.assignee.employeeCode}</div>
                  </div>
                </div>
              ) : (
                <button onClick={() => setShowAssignDrawer(true)} className="text-sm px-3 py-1 border rounded hover:bg-gray-50">+ Assign</button>
              )}
            </div>

            {/* Status & Priority */}
            <div className="flex flex-col items-end gap-2">
              <div>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${form.status === "OPEN" ? "bg-blue-100 text-blue-700" : form.status === "IN_PROGRESS" ? "bg-yellow-100 text-yellow-700" : form.status === "RESOLVED" ? "bg-green-100 text-green-700" : form.status === "CLOSED" ? "bg-gray-100 text-gray-700" : "bg-indigo-100 text-indigo-700"}`}>
                  {form.status}
                </span>
              </div>
              <div>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${form.priority === "LOW" ? "bg-gray-100 text-gray-700" : form.priority === "MEDIUM" ? "bg-yellow-100 text-yellow-700" : form.priority === "HIGH" ? "bg-orange-100 text-orange-700" : "bg-red-100 text-red-700"}`}>
                  {form.priority}
                </span>
              </div>
            </div>
          </div>

          {/* Main area */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Left: Details & Edit */}
            <div className="lg:col-span-2 space-y-4">
              {/* Tabs */}
              <div className="flex gap-4 border-b pb-2">
                <button onClick={() => setActiveTab("details")} className={`flex items-center gap-2 pb-2 ${activeTab === "details" ? "border-b-2 border-indigo-600 font-semibold" : "text-gray-500"}`}><FileText size={16}/> Details</button>
                <button onClick={() => setActiveTab("comments")} className={`flex items-center gap-2 pb-2 ${activeTab === "comments" ? "border-b-2 border-indigo-600 font-semibold" : "text-gray-500"}`}><MessageSquare size={16}/> Comments</button>
                <button onClick={() => setActiveTab("history")} className={`flex items-center gap-2 pb-2 ${activeTab === "history" ? "border-b-2 border-indigo-600 font-semibold" : "text-gray-500"}`}><History size={16}/> History</button>
                <button onClick={() => setActiveTab("attachments")} className={`flex items-center gap-2 pb-2 ${activeTab === "attachments" ? "border-b-2 border-indigo-600 font-semibold" : "text-gray-500"}`}><Paperclip size={16}/> Attachments</button>
              </div>

              {/* Details */}
              {activeTab === "details" && (
                <div className="bg-white p-4 rounded shadow-sm">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm text-gray-600">Category</label>
                      <input name="category" value={form.category} onChange={handleChange} className="w-full p-2 border rounded mt-1" />
                    </div>

                    <div>
                      <label className="text-sm text-gray-600">Subcategory</label>
                      <input name="subcategory" value={form.subcategory} onChange={handleChange} className="w-full p-2 border rounded mt-1" />
                    </div>

                    <div className="md:col-span-2">
                      <label className="text-sm text-gray-600">Title</label>
                      <input name="title" value={form.title} onChange={handleChange} className="w-full p-2 border rounded mt-1" />
                    </div>

                    <div className="md:col-span-2">
                      <label className="text-sm text-gray-600">Description</label>
                      <textarea name="description" value={form.description} onChange={handleChange} rows={6} className="w-full p-2 border rounded mt-1" />
                    </div>

                    <div>
                      <label className="text-sm text-gray-600">Priority</label>
                      <select name="priority" value={form.priority} onChange={handleChange} className="w-full p-2 border rounded mt-1">
                        {PRIORITY_OPTIONS.map((p) => <option key={p} value={p}>{p}</option>)}
                      </select>
                    </div>

                    <div>
                      <label className="text-sm text-gray-600">Status</label>
                      <select name="status" value={form.status} onChange={handleChange} className="w-full p-2 border rounded mt-1">
                        {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {/* Comments */}
              {activeTab === "comments" && (
                <div className="bg-white p-4 rounded shadow-sm">
                  <div className="space-y-3">
                    <div className="flex gap-3">
                      <textarea value={commentText} onChange={(e) => setCommentText(e.target.value)} placeholder="Write a comment..." className="flex-1 p-2 border rounded" rows={3} />
                      <div className="flex flex-col gap-2 items-end">
                        <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
                          <UploadCloud size={16} />
                          <input ref={attachmentRef} type="file" className="hidden" onChange={onCommentFile} />
                        </label>
                        <select value={commentVisibility} onChange={(e) => setCommentVisibility(e.target.value)} className="p-2 border rounded text-sm">
                          <option value="public">Public</option>
                          <option value="internal">Internal</option>
                        </select>
                        <button onClick={postComment} disabled={postingComment} className="bg-indigo-600 text-white px-3 py-2 rounded flex items-center gap-2">
                          <Send size={14}/> {postingComment ? 'Posting...' : 'Post'}
                        </button>
                      </div>
                    </div>

                    <div className="space-y-2 mt-2">
                      {comments.length === 0 && <div className="text-sm text-gray-500">No comments yet.</div>}
                      {comments.map((c, i) => (
                        <div key={i} className="p-3 border rounded">
                          <div className="flex justify-between items-start">
                            <div>
                              <div className="font-medium">{c.commentedBy?.userName || c.commentedBy?.userEmail || 'User'}</div>
                              <div className="text-xs text-gray-500">{new Date(c.createdAt).toLocaleString()} • {c.visibility}</div>
                            </div>
                            {c.attachment && (
                              <a href={c.attachment.url} target="_blank" rel="noreferrer" className="text-sm text-blue-600">Download</a>
                            )}
                          </div>
                          <div className="mt-2 text-sm text-gray-700 whitespace-pre-wrap">{c.comment}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* History */}
              {activeTab === "history" && (
                <div className="bg-white p-4 rounded shadow-sm">
                  <div className="space-y-3">
                    {data.history?.length === 0 && <div className="text-sm text-gray-500">No history available.</div>}
                    {data.history?.map((h, i) => (
                      <div key={i} className="p-3 border rounded flex justify-between">
                        <div>
                          <div className="text-sm font-medium">{h.type}</div>
                          <div className="text-xs text-gray-600">{h.note}</div>
                        </div>
                        <div className="text-xs text-gray-500">{new Date(h.createdAt).toLocaleString()}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Attachments */}
              {activeTab === "attachments" && (
                <div className="bg-white p-4 rounded shadow-sm">
                  <div className="flex items-center justify-between mb-3">
                    <div className="text-sm text-gray-600">Attachments</div>
                    <div className="flex items-center gap-2">
                      <input type="file" onChange={onAttachmentFile} className="hidden" id="attach-input" ref={attachmentRef} />
                      <label htmlFor="attach-input" className="flex items-center gap-2 cursor-pointer border px-3 py-2 rounded text-sm hover:bg-gray-50">
                        <UploadCloud size={16}/> Upload
                      </label>
                    </div>
                  </div>

                  <div className="space-y-2">
                    {attachments.length === 0 && <div className="text-sm text-gray-500">No attachments</div>}
                    {attachments.map((a, idx) => (
                      <div key={idx} className="flex items-center justify-between p-2 border rounded">
                        <a href={a.url} target="_blank" rel="noreferrer" className="text-sm text-blue-600">{a.filename || a.fileName || 'Attachment'}</a>
                        <div className="flex items-center gap-2">
                          <a href={a.url} target="_blank" rel="noreferrer" className="text-sm px-2 py-1 border rounded">View</a>
                          <button onClick={() => removeAttachment(idx)} className="text-sm px-2 py-1 border rounded text-red-600">Delete</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Right column: quick info + actions */}
            <div className="space-y-4">
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="text-sm text-gray-500">Requester</div>
                <div className="mt-2">
                  <div className="font-medium">{data.requester?.userName}</div>
                  <div className="text-xs text-gray-500">{data.requester?.employeeCode} • {data.requester?.userEmail}</div>
                </div>
              </div>
              
              {data.resolver && (
                <div className="bg-white p-4 rounded shadow-sm">
                  <div className="text-sm text-gray-500">Resolver</div>
                  <div className="mt-2">
                    <div className="font-medium">{data.resolver?.userName}</div>
                    <div className="text-xs text-gray-500">{data.resolver?.employeeCode} • {data.resolver?.userEmail}</div>
                  </div>
                </div>
              )}

              <div className="bg-white p-4 rounded shadow-sm">
                <div className="flex justify-between items-center mb-2">
                  <div className="text-sm text-gray-500">SLA</div>
                </div>
                <div className="text-sm">
                  <div>Created: <span className="text-gray-600">{new Date(data.sla?.createdAt).toLocaleString()}</span></div>
                  <div>Due: <span className="text-gray-600">{data.sla?.dueAt ? new Date(data.sla.dueAt).toLocaleString() : 'N/A'}</span></div>
                </div>
              </div>

              <div className="bg-white p-4 rounded shadow-sm">
                <div className="text-sm text-gray-500">Meta</div>
                <div className="mt-2 text-sm text-gray-700 whitespace-pre-wrap">{JSON.stringify(data.meta || {}, null, 2)}</div>
              </div>
            </div>
          </div>

          {/* Assign Drawer */}
          {showAssignDrawer && (
            <div className="fixed inset-0 z-50 flex">
              {/* <div className="absolute inset-0 bg-black opacity-30" onClick={() => setShowAssignDrawer(false)} /> */}
              <div className="ml-auto w-full max-w-md bg-white h-full shadow-xl p-4 overflow-auto">
                <div className="flex items-center justify-between mb-4">
                  <div className="font-semibold">Assign User</div>
                  <button onClick={() => setShowAssignDrawer(false)} className="p-2 rounded hover:bg-gray-100"><X size={16} /></button>
                </div>

                <div className="mb-3">
                  <div className="flex items-center gap-2">
                    <input value={empQuery} onChange={(e) => setEmpQuery(e.target.value)} placeholder="Search employee by name, code or email" className="flex-1 p-2 border rounded" />
                    <button onClick={() => fetchEmployees(empQuery)} className="px-3 py-2 bg-indigo-600 text-white rounded">Search</button>
                  </div>
                </div>

                <div className="space-y-2">
                  {employees.length === 0 && <div className="text-sm text-gray-500">No results</div>}
                  {employees.map((emp) => (
                    <div key={emp._id || emp.id} className="p-2 border rounded flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-semibold">{emp.name?.charAt(0)?.toUpperCase() || emp.userName?.charAt(0)?.toUpperCase()}</div>
                        <div>
                          <div className="font-medium">{emp.name || emp.userName || emp.fullName}</div>
                          <div className="text-xs text-gray-500">{emp.employeeCode || emp.code || ''} • {emp.email || emp.userEmail}</div>
                        </div>
                      </div>
                      <div>
                        <button onClick={() => assignTo(emp)} disabled={assigning} className="px-3 py-1 bg-green-600 text-white rounded">Assign</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

        </div>
      </Container>
    </Layout>
  );
}